/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_Sound_RequiredInputs */

const en_pronunciation_report_sound_required = /** @type {(inputs: Pronunciation_Report_Sound_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us how it should sound.`)
};

const es_pronunciation_report_sound_required = /** @type {(inputs: Pronunciation_Report_Sound_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indica cómo debería sonar.`)
};

/**
* | output |
* | --- |
* | "Tell us how it should sound." |
*
* @param {Pronunciation_Report_Sound_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_sound_required = /** @type {((inputs?: Pronunciation_Report_Sound_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_Sound_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_sound_required(inputs)
	return en_pronunciation_report_sound_required(inputs)
});